module.exports = __webpack_public_path__ + "assets/img/close.8b15a460.svg";